import { useMutation } from "@apollo/react-hooks";
import { useAsyncCallback } from 'react-use-async-callback';
import gql from "graphql-tag";
import { AsyncActionStatus } from '../../../shared/abstractStore';
import { QuestionSequenceQuestionCreateInput } from '../generated/globalTypes';
import { createQuestionSequenceQuestionMutation, createQuestionSequenceQuestionMutationVariables } from '../generated/createQuestionSequenceQuestionMutation';
import { questionSequenceQuestionFieldsFragment } from '../models/QuestionSequenceQuestion';

/**
 * Get a callback to create a QuestionSequenceQuestion in the store.
 */
export function useCreateQuestionSequenceQuestionCallback(): [(model: QuestionSequenceQuestionCreateInput) => Promise<void>, AsyncActionStatus] {
    const [mutationAction, { error }] = useMutation<createQuestionSequenceQuestionMutation, createQuestionSequenceQuestionMutationVariables>(
        gql`
            mutation createQuestionSequenceQuestionMutation ($model: QuestionSequenceQuestionCreateInput!) {
                createQuestionSequenceQuestion(model: $model) {
                    ...questionSequenceQuestionFields
                }
            }

            ${questionSequenceQuestionFieldsFragment}
        `
    );

    // Wrap the mutation in a standard callback.
    const [action, { isExecuting, errors: actionErrors }] = useAsyncCallback(async (model: QuestionSequenceQuestionCreateInput) => {
        const result = await mutationAction({ variables: { model: model } });
        if (result.errors && result.errors.length) {
            throw result.errors;
        }
    }, [mutationAction]);

    return [action, { isExecuting: isExecuting, errors: error ? error.message : actionErrors }];
}
